import sxQuery from "../../sxQuery/sxQuery";
var TOGGLE_CLASS_NAME = 'ss360-multiselect__checkmark--checked';
var TOGGLE_LABEL_CLASS_NAME = 'ss360-multiselect__label--checked';
var FilterCheckbox = /** @class */ (function () {
    function FilterCheckbox(key, name, count, isActive, id, color, isVisible, onChange) {
        if (isVisible === void 0) { isVisible = true; }
        if (onChange === void 0) { onChange = function () { }; }
        this.isActive = false;
        this.isVisible = true;
        this.onChange = function () { };
        this._isAppended = true;
        this.key = key;
        this.name = name;
        this.count = count;
        this.isActive = isActive;
        this.id = id;
        this.color = color;
        this.isVisible = isVisible;
        this.onChange = onChange;
    }
    FilterCheckbox.prototype._render = function () {
        var _this = this;
        var presentationSpan = document.createElement('span');
        presentationSpan.setAttribute('role', 'presentation');
        presentationSpan.setAttribute('aria-controls', this.id);
        presentationSpan.className = "ss360-multiselect__checkmark".concat(this.isActive ? " ".concat(TOGGLE_CLASS_NAME) : '');
        this._presentationSpan = presentationSpan;
        var countString = this.count !== undefined ? ("(".concat(this.count, ")")) : undefined;
        var nameSpan = document.createElement('span');
        nameSpan.textContent = this.name;
        var countSpan = countString !== undefined ? document.createElement('span') : undefined;
        if (countSpan !== undefined) {
            countSpan.className = 'ss360-multiselect__count';
            countSpan.textContent = countString;
        }
        this._countSpan = countSpan;
        var labelNode = document.createElement('label');
        labelNode.setAttribute('for', this.id);
        labelNode.className = "ss360-multiselect__label".concat(this.isActive ? " ".concat(TOGGLE_LABEL_CLASS_NAME) : '');
        labelNode.appendChild(presentationSpan);
        labelNode.appendChild(nameSpan);
        labelNode.setAttribute('title', "".concat(this.name).concat(countString !== undefined ? " ".concat(countString) : ''));
        if (countSpan !== undefined) {
            labelNode.appendChild(countSpan);
        }
        if (this.color !== undefined) {
            var colorNode = document.createElement('span');
            colorNode.className = 'ss360-multiselect__color';
            colorNode.style.backgroundColor = this.color;
            colorNode.setAttribute('role', 'presentation');
            labelNode.appendChild(colorNode);
        }
        this._labelNode = labelNode;
        var wrapperNode = document.createElement('div');
        wrapperNode.className = 'ss360-multiselect__row ss360-flex';
        var inputNode = document.createElement('input');
        inputNode.id = this.id;
        inputNode.type = 'checkbox';
        inputNode.className = 'ss360-multiselect__checkbox';
        this._inputNode = inputNode;
        inputNode.value = this.key;
        if (this.isActive) {
            inputNode.setAttribute('checked', 'checked');
        }
        // FIXME: v15 fix - the padding should be set on the label, not on the div, then this listener won't be necessary
        var onChange = function () {
            _this.onChange(_this.key, !_this.isActive);
            _this.isActive = !_this.isActive;
            _this._onActiveUpdated();
        };
        wrapperNode.addEventListener('click', function (e) {
            var $target = sxQuery(e.target);
            if ($target.hasClass('ss360-multiselect__row')) {
                onChange();
            }
        });
        inputNode.addEventListener('change', function () {
            onChange();
        });
        wrapperNode.appendChild(inputNode);
        wrapperNode.appendChild(labelNode);
        if (!this.isVisible) {
            wrapperNode.setAttribute('style', 'display:none;');
        }
        var checkerRow = sxQuery(undefined);
        checkerRow.push([wrapperNode]);
        this._domNode = checkerRow;
    };
    FilterCheckbox.prototype.getDomNode = function () {
        if (this._domNode === undefined) {
            this._render();
        }
        return this._domNode;
    };
    FilterCheckbox.prototype.show = function () {
        if (this.isVisible || this._domNode === undefined) {
            return;
        }
        this.isVisible = true;
        this._domNode.show();
    };
    FilterCheckbox.prototype.hide = function () {
        if (!this.isVisible || this._domNode === undefined) {
            return;
        }
        this.isVisible = false;
        this._domNode.hide();
    };
    FilterCheckbox.prototype.remove = function () {
        if (!this._isAppended || this._domNode === undefined) {
            return;
        }
        this._isAppended = false;
        this._domNode.remove();
    };
    FilterCheckbox.prototype.ensureLastPosition = function (wrap) {
        var isActive = document.activeElement === this._inputNode;
        wrap.append(this._domNode.get(0));
        if (isActive) {
            sxQuery(this._inputNode).focus();
        }
    };
    FilterCheckbox.prototype.isAppended = function () {
        return this._isAppended;
    };
    FilterCheckbox.prototype.updateCount = function (count) {
        this.count = count;
        var _countSpan = this._countSpan;
        if (count === undefined && _countSpan !== undefined) {
            sxQuery(_countSpan).remove();
        }
        else if (count !== undefined && _countSpan !== undefined) {
            _countSpan.textContent = "(".concat(count, ")");
        }
    };
    FilterCheckbox.prototype._onActiveUpdated = function (updateInput) {
        if (updateInput === void 0) { updateInput = false; }
        var $checkmark = sxQuery(this._presentationSpan);
        var $label = sxQuery(this._labelNode);
        if (this.isActive) {
            $checkmark.addClass(TOGGLE_CLASS_NAME);
            $label.addClass(TOGGLE_LABEL_CLASS_NAME);
        }
        else {
            $checkmark.removeClass(TOGGLE_CLASS_NAME);
            $label.removeClass(TOGGLE_LABEL_CLASS_NAME);
        }
        if (updateInput) {
            sxQuery(this._inputNode).attr('checked', this.isActive ? 'checked' : null);
        }
    };
    FilterCheckbox.prototype.updateActive = function (isActive) {
        this.isActive = isActive;
        this._onActiveUpdated(true);
    };
    return FilterCheckbox;
}());
export default FilterCheckbox;
